import CtaIconBox from './ctaIconBox';

export default CtaIconBox;
